import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-bs4';
const dummyStreetStocks = [
  {
    id: 1,
    title: 'Stock Title 1',
    message: 'This is a message for stock 1.',
    src_url: 'path/to/image1.jpg',
    created_on: '2024-01-01 10:00:00',
  },
  {
    id: 2,
    title: 'Stock Title 2',
    message: 'This is a message for stock 2.',
    src_url: 'path/to/image2.jpg',
    created_on: '2024-01-02 11:00:00',
  },
  // Add more dummy records as needed
];

const StreetStocks = () => {
  const [sdate, setSdate] = useState('');
  const [edate, setEdate] = useState('');
  const totalRecords = dummyStreetStocks.length;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted with:', { sdate, edate });
  };

  const handleClear = () => {
    setSdate('');
    setEdate('');
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="row pb-2">
          <div className="col-md-6">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/dashboard"><i className="ti ti-home"></i> Home</a>
              </li>
              <li className="breadcrumb-item active">Street Stocks</li>
            </ul>
          </div>
          <div className="col-md-6" style={{ textAlign: 'right' }}>
            <button className="btn btn-default btn-sm pull-right">
              <i className="ti ti-export"></i> Export
            </button>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} encType="multipart/form-data" className="stdform">
            <div className="panel-heading border-0">
              <span className="panel-title">Street Stocks</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Title"
                      onChange={(e) => console.log('Title:', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Message</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Message"
                      onChange={(e) => console.log('Message:', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Notification Image</label>
                    <input type="file" className="form-control" />
                  </div>
                </div>
                <div className="col-md-3">
                  <button type="submit" className="btn btn-primary mt-4">Submit</button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <div className="panel-heading border-0">
              <span className="panel-title">Search Street Stocks</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={sdate}
                      onChange={(e) => setSdate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={edate}
                      onChange={(e) => setEdate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <button type="submit" className="btn btn-primary mt-4">Submit</button>
                  <button type="button" className="btn btn-danger mt-4 mx-2" onClick={handleClear}>Clear All</button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow p-10">
          <div className="panel-heading border-0">
            <span className="panel-title">Notification Reports</span>
            <span className="pull-right">Total Records: {totalRecords}</span>
          </div>
          {totalRecords > 0 ? (
            <table className="table table-condensed table-bordered bg-white">
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>#</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Message To</th>
                  <th>Image</th>
                  <th>Created On</th>
                </tr>
              </thead>
              <tbody>
                {dummyStreetStocks.map((post, index) => (
                  <tr key={post.id}>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{index + 1}</td>
                    <td>{post.title}</td>
                    <td>{post.message}</td>
                    <td><a href={`/research/streetstocks/View/${post.id}`} target="_blank" rel="noopener noreferrer">View</a></td>
                    <td>
                      {post.src_url && (
                        <a href={post.src_url} target="_blank" rel="noopener noreferrer">View Image</a>
                      )}
                    </td>
                    <td>{post.created_on}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>No records found.</div>
          )}
        </div>
      </div>

      {/* Scroll to top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default StreetStocks;
